var Faqs = $.extend(false, BaseModule ,{

    api_route : 'faqs',

	data : {
        module          :'faqs',
        view            : 'list',
        limit            : 20,
        details_with    : 'products.item',
        pagination      : true
    },

     save_order:function(){
        var module_name = this.data.module,
            module = this,
            selection = [];
        
        $('input[name="order_item_id[]"]').each(function(){
            selection.push($(this).val());
        });

        $.ajax({
            url : API + module.api_route + '/order',
            method:'POST',
            data:{ 
                show_in: $('#'+module_name+'-dialog-list  select[name="show_in"]').val(),
                order_item_id: selection 
            },
            success:function(data){
                $("#"+module_name+"-dialog-list").modal('hide');
            }
        });
        return false;
    },

	init:function(){
        var module_name = this.data.module,  module = this;
    }
});

$(document).ready(function(){
    "use strict";
	Faqs.init();
});
